import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/empresas/archivos-de-direcciones-verificadas/';

/**
 * GET ArchivosDeDireccionesVerificadas
 * @returns {Promise<Array<object>>}
 */
export const getArchivosDeDireccionesVerificadas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET ArchivoDeDireccionVerificada
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getArchivoDeDireccionVerificada = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST ArchivoDeDireccionVerificada
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postArchivoDeDireccionVerificada = async (values) => {
  try {
    const response = await API.post(baseURI, values, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH ArchivoDeDireccionVerificada
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchArchivoDeDireccionVerificada = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE ArchivoDeDireccionVerificada
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteArchivoDeDireccionVerificada = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
